import { Theme } from "interfaces/theme";
import React from "react";

import * as S from "./styles";

interface IFooter {
  mode: Theme;
}
const Footer: React.FC<IFooter> = ({ mode }) => {
  return (
    <S.Container mode={mode}>
      <S.Header>Créditos</S.Header>
      <S.Wrapper>
        <S.Column>
          <div>
            <span>Modelos::</span>
            <h6>
              Julia Baumgartner, Lais Scolaro, Kathe Rocha, Sara Castro e Guive{" "}
            </h6>
          </div>
          <div>
            <span>Tratamento de imagem:</span>
            <h6>Thiago Auge</h6>
          </div>
          <div>
            <span>Assistente de produção de moda:</span>
            <h6>Thiago Torres</h6>
          </div>
        </S.Column>
        <S.Column>
          <div>
            <span>Coordenação de produção de moda:</span>
            <h6>Diego Tofolo</h6>
          </div>
          <div>
            <span>Produção de set:</span>
            <h6>Ronaldo Junge e Carlos Henrique</h6>
          </div>
          <div>
            <span>Camareira:</span>
            <h6>Egle Doxum</h6>
          </div>
        </S.Column>
        <S.Column>
          <div>
            <span>Manicure:</span>
            <h6>Thayna Dandara</h6>
          </div>
          <div>
            <span>Assistentes de foto:</span>
            <h6>Tate Toledo e Bruna Hissae</h6>
          </div>
        </S.Column>
        <S.Column>
          <div>
            <span>Produção executiva:</span>
            <h6>Isabela de Paula</h6>
          </div>
          <div>
            <span>Assistentes de beleza:</span>
            <h6>Julia Bachesque, Juliana Coelho e Chris Ravenna</h6>
          </div>
        </S.Column>
      </S.Wrapper>
    </S.Container>
  );
};

export default Footer;
